__webpack_require__.p = "/nft_internship_project/";